import { combineReducers } from "redux";

import Layout from "store/layout/reducer";
import Login from "store/auth/reducer";
import User from "store/users/reducer";
import Client from "store/clients/reducer";
import Vehicle from "store/vehicles/reducer";
import Rate from "store/rates/reducer";
import Billing from "store/billing/reducer";
import Payment from "store/payments/reducer";

const rootReducer = combineReducers({
  Layout,
  Login,
  User,
  Client,
  Vehicle,
  Rate,
  Billing,
  Payment,
});

export default rootReducer;
